import { render, staticRenderFns } from "./ChineesGame.vue?vue&type=template&id=2b1b06e4&"
import script from "./ChineesGame.vue?vue&type=script&lang=js&"
export * from "./ChineesGame.vue?vue&type=script&lang=js&"
import style0 from "./ChineesGame.vue?vue&type=style&index=0&id=2b1b06e4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports